import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import homeLogo from "../../Assets/avater-Photoroom.png";
import ParticlesBg from "../Background/ParticlesBg";
import Type from "./Type";

function Home() {
  return (
    <Container fluid className="home-section" id="home">
      <ParticlesBg />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
            className="home-header"
          >
            <h1 style={{ paddingBottom: 15 }} className="heading">
              Hello There!{" "}
              <span className="wave" role="img" aria-labelledby="wave">
                👋🏻
              </span>
            </h1>

            <h1 className="heading-name">
              I'm
              <strong className="main-name">  Chenyu Wu</strong>
            </h1>

            <div style={{ paddingTop: "30px", textAlign: "left" }}>
              <Type />
            </div>
          </Col>

          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
          >
            <img
              src={homeLogo}
              alt="home pic"
              className="img-fluid"
              style={{ maxHeight: "450px" }}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home;
